export const PASSWORD_CHARS = [
  '0123456789',
  'ABCDEFGHIJKLMNPQRSTUVWXYZ',
  'abcdefghijklmnpqrstuvwxyz',
  '!"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~',
];
